<template>
    <div v-if="$route.name == 'splash-dev'" id="newMenu">
        <div id="mainMenu">
            Studio JMMP
        </div>
    </div>
    <div id="newMenu" ref="menu" v-else>
        <div id="mainMenu">
            <router-link
                :to="this.store.lastSwipe"
                :class="{ active: routeIsHome }"
                >Slideshow</router-link
            >
            <router-link
                :to="{ name: this.store.lastProject }"
                :class="{ active: routeIsProjects || routeIsProjectDetail }"
                >Projects</router-link
            >
            <router-link
                :to="{ name: this.store.lastIndex }"
                :class="{ active: routeIsIndex }"
                >Index</router-link
            >
            <router-link
                :to="{ name: this.store.lastAbout }"
                :class="{ active: routeIsAbout }"
                >About</router-link
            >
        </div>

        <div id="subMenu" v-if="routeIsHome">
            <span @click="makeRandom" :class="{ active: store.random }"
                >Shuffle</span
            >
            <span @click="makeLinear" :class="{ active: !store.random }"
                >Chronological</span
            >
        </div>
        <div id="subMenu" v-if="routeIsProjects">
            <router-link
                :to="{ name: 'project-list-identities' }"
                :class="{ active: $route.name == 'project-list-identities' }"
                >Identities</router-link
            >
            <router-link
                :to="{ name: 'project-list-books' }"
                :class="{ active: $route.name == 'project-list-books' }"
                >Publications</router-link
            >
            <router-link
                :to="{ name: 'project-list-websites' }"
                :class="{ active: $route.name == 'project-list-websites' }"
                >Websites</router-link
            >
            <router-link
                :to="{ name: 'project-list-typefaces' }"
                :class="{ active: $route.name == 'project-list-typefaces' }"
                >Typefaces</router-link
            >
        </div>
        <div id="subMenu" v-else-if="routeIsIndex">
            <router-link
                :to="{ name: 'images-dev' }"
                :class="{ active: $route.name == 'images-dev' }"
                >Image</router-link
            >
            <router-link
                :to="{ name: 'index-dev' }"
                :class="{ active: $route.name == 'index-dev' }"
                >Text</router-link
            >
        </div>
        <!-- <div id="subMenu" v-else-if="routeIsAbout"> -->
        <!--     <div -->
        <!--         id="marker2" -->
        <!--         :class="$route.name == 'studio-image-dev' ? 'images' : 'index'" -->
        <!--     ></div> -->
        <!--     <div id="text"> -->
        <!--         <router-link -->
        <!--             :to="{ name: 'studio-dev' }" -->
        <!--             :class="{ active: $route.name == 'studio-dev' }" -->
        <!--             >Text</router-link -->
        <!--         > -->
        <!--     </div> -->
        <!--     <div id="image"> -->
        <!--         <router-link -->
        <!--             :to="{ name: 'studio-image-dev' }" -->
        <!--             :class="{ active: $route.name == 'studio-image-dev' }" -->
        <!--             >Image</router-link -->
        <!--         > -->
        <!--     </div> -->
        <!-- </div> -->
    </div>
</template>

<script>
import { store } from "@/centralStore";

export default {
    name: "NewNewMenu",
    props: [],
    data() {
        return {
            store: store.state
        };
    },
    computed: {
        getRouteName() {
            if (this.store.splashPage) {
                return "";
            }
            if (this.routeIsHome) {
                return "Slideshow";
            } else if (this.routeIsIndex) {
                return "Index";
            } else if (this.routeIsAbout) {
                return "About";
            }
        },
        routeIsHome() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "detail" ||
                    this.$route.name == "swipe-slug" ||
                    this.$route.name == "swipe-image" ||
                    this.$route.name == "swipe" ||
                    this.$route.name == "detail-slug" ||
                    this.$route.name == "detail-image")
            ) {
                return true;
            } else {
                return false;
            }
        },
        routeIsProjects() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "project-list-books" ||
                    this.$route.name == "project-list-websites" ||
                    this.$route.name == "project-list-typefaces" ||
                    this.$route.name == "project-list-identities")
            ) {
                return true;
            } else {
                return false;
            }
        },
        routeIsProjectDetail() {
            if (
                !this.store.splashPage &&
                this.$route.name == "project-detail"
            ) {
                return true;
            } else {
                return false;
            }
        },
        routeIsIndex() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "index-dev" ||
                    this.$route.name == "images-dev")
            ) {
                return true;
            } else {
                return false;
            }
        },
        routeIsAbout() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "studio-dev" ||
                    this.$route.name == "studio-image-dev")
            ) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        makeRandom() {
            this.store.random = true;
            this.store.swipeImages = this.store.shuffledImages;
        },
        makeLinear() {
            this.store.random = false;
            this.store.swipeImages = this.store.orderedImages;
        }
    }
};
</script>

<style scoped>
#newMenu {
    /* position: fixed; */
    top: 1rem;
    left: 1rem;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 1.25rem;
    align-items: center;
    gap: 0.5em;
    padding-bottom: 2rem;
    padding-top: 2rem;
}

@media screen and (min-width: 768px) {
    #newMenu {
        font-size: 0.75rem;
        width: 100%;
        justify-content: space-between;
    }
}

#mainMenu {
}

@media screen and (min-width: 768px) {
    #mainMenu {
    }
}

#mainMenu,
#subMenu {
    position: relative;
    display: flex;
    justify-content: space-between;
    gap: 1em;
    align-items: center;
    justify-content: center;
}

@media screen and (min-width: 768px) {
    #mainMenu,
    #subMenu {
    }
}

#slideshow {
    width: 6.5rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem 0 0;
}

#index {
    width: 3.5rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem;
}

#about {
    width: 4.1rem;
    z-index: 1;
    text-align: center;
    margin: 0 0 0 1rem;
}

#shuffle {
    width: 4.4rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem 0 0;
}

#linear {
    width: 4.1rem;
    z-index: 1;
    text-align: center;
    margin: 0 0 0 1rem;
}

#text {
    width: 3.1rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem 0 0;
}

#image {
    width: 4.2rem;
    z-index: 1;
    text-align: center;
    margin: 0 0 0 1rem;
}

@media screen and (min-width: 768px) {
    #slideshow {
        width: 3.8rem;
    }

    #index {
        width: 2.2rem;
    }

    #about {
        width: 2.3rem;
    }

    #shuffle {
        width: 2.6rem;
    }

    #linear {
        width: 2.4rem;
    }

    #text {
        width: 1.7rem;
    }

    #image {
        width: 2.4rem;
    }
}

#mainMenu a,
#mainMenu span,
#subMenu a,
#subMenu span {
    color: #969696;
    text-decoration: none;
    transition: color 0.2s;
    z-index: 1;
    text-align: center;
    cursor: pointer;
}
@media screen and (min-width: 768px) {
    #mainMenu a:hover,
    #mainMenu span:hover,
    #subMenu a:hover,
    #subMenu span:hover {
        color: white;
    }
}

#mainMenu > a:last-child,
#subMenu > a:last-child,
#subMenu > span:last-child {
    margin-right: 0;
}

#mainMenu a.active,
#subMenu a.active,
#subMenu span.active {
    color: white;
    /* font-family: "JMMP Medium"; */
    /* font-feature-settings: 'ss01' on; */
}

#marker,
#marker2 {
    position: absolute;
    left: 0;
    border-radius: 2rem;
    background-color: white;
    top: 0;
    color: white;
    transition: width 0.15s, left 0.15s;
    height: 1.4rem;
    width: 0;
    padding: 0;
}

#subMenu > div {
    transition: width 0.15s, left 0.15s;
}

@media screen and (min-width: 768px) {
    #marker,
    #marker2 {
        height: 0.3rem;
    }
}

#marker.Slideshow {
    width: 6.5rem;
    left: 0;
    padding: 1rem;
}

#marker.Index {
    width: 3.9rem;
    left: 8.3rem;
    padding: 1rem;
}

#marker.About {
    width: 4.1rem;
    left: 14rem;
    padding: 1rem;
}

#marker2.shuffle {
    width: 4.4rem;
    left: 0;
    padding: 1rem;
}

#marker2.linear {
    width: 4.1rem;
    left: 6.4rem;
    padding: 1rem;
}

#marker2.index {
    width: 3.1rem;
    left: 0;
    padding: 1rem;
}

#marker2.images {
    width: 4.2rem;
    left: 5.2rem;
    padding: 1rem;
}

@media screen and (min-width: 768px) {
    #marker.Slideshow {
        width: 3.8rem;
    }

    #marker.Index {
        width: 2.1rem;
        left: 5.9rem;
    }

    #marker.About {
        width: 2.3rem;
        left: 10rem;
    }

    #marker2.shuffle {
        width: 2.6rem;
    }

    #marker2.linear {
        width: 2.4rem;
        left: 4.6rem;
    }

    #marker2.index {
        width: 1.7rem;
    }

    #marker2.images {
        width: 2.4rem;
        left: 3.7rem;
    }
}

#shuffle,
#linear {
    cursor: pointer;
}
</style>
